'use strict';

exports.__esModule = true;
exports.FiltersConatiner = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  width: 485px;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: 485px;\n  justify-content: space-between;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var FiltersConatiner = exports.FiltersConatiner = _styledComponents2.default.div(_templateObject);